import React from "react"

export const LayoutEditUser=()=> {

  return (
    <>LayoutEditUser</>
  )
}
